/* global google */

// TODO:....add some comments
( function ( $ ) {
	$( document ).ready( function () {
		var $mapSection = $( '[data-map-section]' );

		if ( $mapSection && $mapSection.length ) {
			var $mapContainer = $mapSection.find( '[data-google-map]' );
			var $mapForm = $mapSection.find( '[data-map-form]' );
			var action = $mapForm.attr( 'action' );
			var method = $mapForm.attr( 'method' );
			var $resultListContainer = $mapSection.find( '[data-results-list]' );
			var resultTemplateHtml = $mapSection.find( '#map-section-result-template' ).html().trim();
			var $resultTemplate = $( resultTemplateHtml );
			var resultSeasonTemplateHtml = $mapSection.find( '#map-section-result-season-template' ).html().trim();
			var $resultSeasonTemplate = $( resultSeasonTemplateHtml );
			var noResultsTemplateHtml = $mapSection.find( '#map-section-no-results-template' ).html().trim();
			var $noResultsTemplate = $( noResultsTemplateHtml );
			var submittingClass = 'map-section--loading';
			var initClass = 'map-section--init';
			// Commenting out potentially temporarilly to reduce API charges.
			// var map = new google.maps.Map( $mapContainer[0], {
			// 	center: { lat: 41.850033, lng: -95.6500523 },
			// 	zoom: 3.6,
			// 	maxZoom: 10
			// } );
			var map = null;
			var markersArray = [];
			var infoWindowArray = [];

			// Commenting out potentially temporarilly to reduce API charges.
			// var localStoreAvail = storageAvailable( 'localStorage' );

			// if( navigator.geolocation ) {
			// 	navigator.geolocation.getCurrentPosition( function( position ) {
			// 		var lat = position.coords.latitude;
			// 		var long = position.coords.longitude;
			// 		var latFixed = lat.toFixed( 3 );
			// 		var longFixed = long.toFixed( 3 );

			// 		if ( localStoreAvail ) {
			// 			var zip = localStorage.getItem( 'leagueMapZip_' + latFixed + '_' + longFixed );

			// 			if ( zip ) {
			// 				$mapForm.find( '[name="zip"]' ).val( zip );
			// 				// $mapForm.submit();
			// 			} else {
			// 				setZipFromCoords( latFixed, longFixed, $mapForm, localStoreAvail );
			// 			}
			// 		} else {
			// 			setZipFromCoords( latFixed, longFixed, $mapForm, localStoreAvail );
			// 		}
			// 	} );
			// }

			$mapForm.on( 'submit', function( e ) {
				e.preventDefault();
				if ( !map ) {
					map = new google.maps.Map( $mapContainer[0], {
						center: { lat: 41.850033, lng: -95.6500523 },
						zoom: 3.6,
						maxZoom: 10
					} );
				}

				var formData = new FormData( $mapForm[0] );
				var formDataEntriesObject = {};
				var formEntries = Array.from( formData.entries() );

				for ( var i=0; i < formEntries.length; i++ ) {
					var entry = formEntries[i];
					var key = entry[0];
					var value = entry[1];
					if ( key === 'radius' ) {
						formDataEntriesObject[key] = parseInt( value );
					} else {
						formDataEntriesObject[key] = value;
					}
				}

				$mapSection.addClass( submittingClass );
				$mapSection.removeClass( initClass );

				$.ajax( {
					url: action,
					accepts: {
						json: 'application/json'
					},
					contentType: 'application/json',
					method: method,
					data: JSON.stringify( formDataEntriesObject )
				} ).done( function( response ) {
					var results = response.data;
					markersArray.forEach( function ( curMarker ) {
						curMarker.setMap( null );
					} );
					markersArray = [];
					infoWindowArray = [];

					if ( results && results.length ) {
						var $resultElements = $();
						
						results.forEach( function( curResult ) {
							var resultLatlng = new google.maps.LatLng(
								curResult.latitude,
								curResult.longitude
							);
							var resultMarker = new google.maps.Marker( {
								map: map,
								position: resultLatlng,
								title: curResult.name
							} );

							markersArray.push( resultMarker );
							var $newResult = $resultTemplate.clone();
							var divisionArray = [];
							if ( curResult.has_coed ) {
								divisionArray.push( 'Co-ed' );
							}

							if ( curResult.has_girls ) {
								divisionArray.push( 'Girls' );
							}

							if ( curResult.has_boys ) {
								divisionArray.push( 'Boys' );
							}

							$newResult.find( '[data-title]' ).text( curResult.name );

							if ( curResult.website ) {
								$newResult.find( '[data-website]' ).attr( 'href', curResult.website ).text( curResult.website );
							} else {
								$newResult.find( '[data-website-item]' ).remove();
							}

							if ( curResult.min_age && curResult.max_age ) {
								$newResult.find( '[data-ages]' ).text( curResult.min_age + '-' + curResult.max_age );
							} else {
								$newResult.find( '[data-ages-item]' ).remove();
							}

							if ( curResult.divisionArray && curResult.divisionArray.length ) {
								$newResult.find( '[data-divisions]' ).text(
									divisionArray.reduce(
										function ( prevValue, curValue ) {
											return prevValue + ', ' + curValue;
										}
									)
								);
							} else {
								$newResult.find( '[data-divisions-item]' ).remove();
							}

							var $newResultSeasons =  $();
							var resultSeasons = curResult.active_seasons;

							if ( resultSeasons && resultSeasons.length ) {
								resultSeasons.forEach( function( curSeason ) {
									var $newSeason = $resultSeasonTemplate.clone();
									var formatOptions = { month: 'short', day: 'numeric' };
									if ( curSeason.start_date && curSeason.end_date ) {
										var seasonStartDate = new Date( curSeason.start_date );
										var seasonEndDate = new Date( curSeason.end_date );
										$newSeason.find( '[data-season-label]' ).removeClass( 'sr-only' );
										$newSeason.find( '[data-season]' ).text( seasonStartDate.toLocaleDateString( 'en-US', formatOptions ) + ' - ' + seasonEndDate.toLocaleDateString( 'en-US', formatOptions ) );
									}

									if ( curSeason.registration_start_date && curSeason.registration_end_date ) {
										var registrationStartDate = new Date( curSeason.registration_start_date );
										var registrationEndDate = new Date( curSeason.registration_end_date );
										$newSeason.find( '[data-registration-label]' ).removeClass( 'sr-only' );
										$newSeason.find( '[data-registration]' ).text( registrationStartDate.toLocaleDateString( 'en-US', formatOptions ) + ' - ' + registrationEndDate.toLocaleDateString( 'en-US', formatOptions ) );
									}

									$newResultSeasons = $newResultSeasons.add( $newSeason );
								} );
								$newResult.find( '[data-seasons-list]' ).append( $newResultSeasons );
							} else {
								var $newSeason = $resultSeasonTemplate.clone();
								$newResultSeasons = $newResultSeasons.add( $newSeason );
								$newResult.find( '[data-seasons-list]' ).append( $newResultSeasons );
							}

							var markerInfoWindow = new google.maps.InfoWindow( {
								content: $newResult.html()
							} );

							infoWindowArray.push( markerInfoWindow );

							resultMarker.addListener( 'click', function() {
								infoWindowArray.forEach( function( curWin ) { curWin.close(); } );
								markerInfoWindow.open( map, resultMarker );
							} );

							$resultElements = $resultElements.add( $newResult );
						} );
						$resultListContainer.html( $resultElements );

						var bounds = new google.maps.LatLngBounds();
						markersArray.forEach( function ( curMarker ) {
							bounds.extend( curMarker.position );
						} );
						map.fitBounds( bounds );
					} else {
						var $noResultsElement = $noResultsTemplate.clone();
						$resultListContainer.html( $noResultsElement );
						map.setCenter( { lat: 41.850033, lng: -95.6500523 } );
						map.setZoom( 3.6 );
					}

					$mapSection.removeClass( submittingClass );
				} );
			} );

			$resultListContainer.on( 'click mouseenter', '> *', function() {
				var $el = $( this );
				var aniDuration = 375;

				if ( markersArray && markersArray.length ) {
					markersArray[$el.index()].setAnimation( google.maps.Animation.BOUNCE );
				}

				setTimeout (
					function() {
						if ( markersArray && markersArray.length ) {
							markersArray[$el.index()].setAnimation( null );
						}
					},
					aniDuration
				);
			} );
		}
	} );

	// function setZipFromCoords( lat, long, $mapForm, localStoreAvail ) {
	// 	var geocoder = new google.maps.Geocoder();
	// 	var latlng = new google.maps.LatLng( lat, long );
	// 	geocoder.geocode( { 'location': latlng }, function ( results, status ) {
	// 		if ( status == 'OK' ) {
	// 			var zipResult = results.find( function( curRes ) { return curRes.types.indexOf( 'postal_code' ) !== -1; } );
	// 			var zipComp = zipResult.address_components.find( function( curComp ) { return curComp.types.indexOf( 'postal_code' ) !== -1; } );
	// 			var zip = zipComp.long_name;
	// 			$mapForm.find( '[name="zip"]' ).val( zip );
	// 			// Commenting out potentially temporarilly to reduce API charges.
	// 			// $mapForm.submit();

	// 			if ( localStoreAvail ) {
	// 				localStorage.setItem( 'leagueMapZip_' + lat + '_' + long, zip );
	// 			}
	// 		} else {
	// 			// TODO: not sure what to do for a failure here. For now do nothing. Look into further time permitting.
	// 		}
	// 	} );
	// }

	// function storageAvailable( type ) {
	// 	var storage;
	// 	try {
	// 		storage = window[type];
	// 		var x = '__storage_test__';
	// 		storage.setItem( x, x );
	// 		storage.removeItem( x );
	// 		return true;
	// 	}
	// 	catch ( e ) {
	// 		return e instanceof DOMException && (
	// 			// everything except Firefox
	// 			e.code === 22 ||
	// 			// Firefox
	// 			e.code === 1014 ||
	// 			// test name field too, because code might not be present
	// 			// everything except Firefox
	// 			e.name === 'QuotaExceededError' ||
	// 			// Firefox
	// 			e.name === 'NS_ERROR_DOM_QUOTA_REACHED' ) &&
	// 			// acknowledge QuotaExceededError only if there's something already stored
	// 			( storage && storage.length !== 0 );
	// 	}
	// }
} )( jQuery );
